var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.34 20.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #003189;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8967",
    "data-name": "Path 8967",
    className: "cls-1",
    d: "M26.4,18.58h-9.43c-.52,0-.94-.42-.94-.93s.42-.94.93-.94h9.44c.52,0,.93.42.93.94,0,.52-.42.93-.93.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8968",
    "data-name": "Path 8968",
    className: "cls-1",
    d: "M14.7,20.85c-1.77,0-3.2-1.43-3.2-3.2s1.43-3.2,3.2-3.2c1.77,0,3.2,1.43,3.2,3.2h0c0,1.77-1.43,3.2-3.2,3.2M14.7,16.31c-.74,0-1.33.6-1.33,1.33s.6,1.33,1.33,1.33,1.33-.6,1.33-1.33h0c0-.74-.6-1.33-1.33-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8969",
    "data-name": "Path 8969",
    className: "cls-1",
    d: "M12.43,18.58H.94C.42,18.58,0,18.16,0,17.64c0-.52.42-.94.93-.94h11.5c.52,0,.94.42.94.93s-.42.94-.93.94h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8970",
    "data-name": "Path 8970",
    className: "cls-1",
    d: "M26.4,11.35H8.37c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h18.03c.52,0,.94.42.94.94s-.42.94-.94.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8971",
    "data-name": "Path 8971",
    className: "cls-1",
    d: "M6.11,13.62c-1.77,0-3.2-1.43-3.2-3.2s1.43-3.2,3.2-3.2,3.2,1.43,3.2,3.2h0c0,1.77-1.43,3.2-3.2,3.2M6.11,9.08c-.74,0-1.33.6-1.33,1.33,0,.74.6,1.33,1.33,1.33s1.33-.6,1.33-1.33c0-.74-.6-1.33-1.33-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8972",
    "data-name": "Path 8972",
    className: "cls-1",
    d: "M3.84,11.35H.94C.42,11.35,0,10.93,0,10.42s.42-.94.94-.94h2.9c.52,0,.94.42.94.94s-.42.94-.94.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8973",
    "data-name": "Path 8973",
    className: "cls-1",
    d: "M17.61,4.13H.94c-.52,0-.94-.42-.94-.94,0-.52.42-.94.94-.94h16.67c.52,0,.94.42.94.94s-.42.94-.94.94h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8974",
    "data-name": "Path 8974",
    className: "cls-1",
    d: "M19.88,6.4c-1.77,0-3.2-1.43-3.2-3.2,0-1.77,1.43-3.2,3.2-3.2,1.77,0,3.2,1.43,3.2,3.2h0c0,1.77-1.43,3.2-3.2,3.2M19.88,1.86c-.74,0-1.33.59-1.34,1.33s.59,1.33,1.33,1.34,1.33-.59,1.34-1.33c0,0,0,0,0,0,0-.73-.6-1.33-1.33-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8975",
    "data-name": "Path 8975",
    className: "cls-1",
    d: "M26.4,4.13h-4.25c-.52,0-.94-.42-.94-.94,0-.52.42-.94.94-.94h4.25c.52,0,.94.42.94.94,0,.52-.42.94-.94.94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFilters);
export default __webpack_public_path__ + "static/media/ico-filters.72f98cf24a671adf8cb32a9915b43040.svg";
export { ForwardRef as ReactComponent };